import { c as _c } from "react/compiler-runtime";
import { ActivityApiClient } from "@api/activity-api/activity-api-client";
import { CLIENT_ID } from "@api/client-id";
import { useCachedCompanyTokenProvider } from "@api/use-cached-company-token-provider";
import { runtimeConfig } from "@src/runtime-config";
import { useMemo } from "react";
/** Custom hook that initializes the activity API client and returns an instance of it */
export function useActivityApiClient(t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    companyId,
    projectId,
    activity
  } = t1;
  let t2;
  if ($[2] !== activity || $[3] !== companyId || $[4] !== projectId) {
    t2 = {
      companyId,
      projectId,
      activity
    };
    $[2] = activity;
    $[3] = companyId;
    $[4] = projectId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const tokenProvider = useCachedCompanyTokenProvider(t2);
  let t3;
  if ($[6] !== companyId || $[7] !== projectId || $[8] !== tokenProvider) {
    t3 = new ActivityApiClient({
      activityApiBaseUrl: runtimeConfig.urls.activityApiUrl,
      companyId,
      projectId,
      tokenProvider,
      clientId: CLIENT_ID
    });
    $[6] = companyId;
    $[7] = projectId;
    $[8] = tokenProvider;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}